import { ref } from 'vue';
import { useRouter } from 'vue-router';
import axios from 'axios';

export default {
  name: 'LoginView',
  setup() {
    const email = ref('');
    const password = ref('');
    const router = useRouter();

    const login = async () => {
      // Hardcoded credentials for demonstration
      if (email.value === 'balticai@gmail.com' && password.value === 'admin') {
        // Simulate successful login without backend call
        localStorage.setItem('token', 'demo-token-12345');
        router.push('/dashboard');
        return;
      }

      try {
        const payload = new URLSearchParams();
        payload.append('username', email.value);
        payload.append('password', password.value);

        const response = await axios.post(
          `${process.env.VUE_APP_API_URL}/auth/login`,
          payload,
          {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
            }
          }
        );

        localStorage.setItem('token', response.data.access_token);
        router.push('/dashboard');
      } catch (error) {
        console.error('Login failed:', error);
        alert('Login failed. Please check your credentials and try again.');
      }
    };

    return { email, password, login };
  },
};
